export default {
  leagues: {
    title: "Seleziona lega",
    empty: {
      favoriteLeagues: "Aggiungi le tue leghe preferite in alto per accedervi più rapidamente",
    },
    actions: {
      starFavoriteLeagues: "Aggiungi leghe preferite",
    },
    status: {
      live: "Attivo",
      offseason: "Fuori stagione",
    },
    sections: {
      myLeagues: "Le mie leghe",
      sports: {
        baseball: "Baseball",
        basketball: "Basket",
        football: "Football americano",
        "australian-football": "Football australiano",
        rugby: "Rugby",
        hockey: "Hockey",
        soccer: "Calcio",
      },
    },
  },
};
